



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class SearchCustomerInformationInput extends Vue {
    @Prop()
    label!: string;

    @Prop()
    value!: string;

    @Prop()
    name!: string;

    @Prop()
    icon!: string;

    @Prop()
    disabled!: boolean;

    @Prop()
    isLoading!: boolean;

    @Prop({ default: false })
    isEditing!: boolean;

    get marginTop() {
        return { "mt-1": this.name === "address" || this.name === "phone2" };
    }

    get localValue() {
        return this.value;
    }

    set localValue(val) {
        this.$emit("input", val);
    }
}
